
export type RequestAdminAccountRefund200 = {
  message: string;
  /** @nullable */
  orderId?: string | null;
  /** @nullable */
  subscriptionId?: number | null;
  success?: boolean;
  /** @nullable */
  userId?: string | null;
};
